module.exports = global["tinycolor"] = require("-!./tinycolor.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?tinycolor!../node_modules/tinycolor2/tinycolor.js-exposed
// module id = 547
// module chunks = 3